<script lang="ts">
  import { link, push } from "svelte-spa-router";

  import Button from "$lib/ui/button/button.svelte";

  import Step1 from "$assets/images/step_1.png";
  import Step2 from "$assets/images/step_2.png";
  import Step3 from "$assets/images/step_3.png";

  import { selectedOrgStore } from "$lib/stores/orgs";
  import { makeApiRequest } from "$lib/utils/api";
  import { LoadingSpinner } from "$lib/ui/loading-spinner";
  import { userStore } from "$lib/stores/user";
  import { onMount } from "svelte";

  const steps = [
    {
      title: "Authorize your SSO provider",
      description: "Connect Permissions Assurance to your SSO provider, such as Microsoft Entra, Okta, etc.",
      icon: Step1,
      requires: "SSO admin's permission",
    },
    {
      title: "Connect your date sources",
      description: "Connect your data sources to Permissions Assurance, such as Sharepoint, Drive, Confluence etc.",
      icon: Step2,
      requires: "Admin's permission of each data source",
    },
    {
      title: "Review",
      description: "Confirm details you've provided and start your organization's scan.",
      icon: Step3,
    },
  ];

  let isSubmitting = $state(false);

  async function startOnboarding() {
    isSubmitting = true;
    try {
      if (!$selectedOrgStore) {
        await makeApiRequest("/org-setup/create", {}, "POST");
      }

      await push("/onboarding/connect_sso");
    } finally {
      isSubmitting = false;
    }
  }
  onMount(async () => {
    if ($userStore?.organisation_setup_id || $selectedOrgStore) {
      if ($selectedOrgStore?.sso?.connected && !$selectedOrgStore?.dataSources?.find((x) => x.connected)) {
        await push("/onboarding/connect_data");
      } else {
        await push("/onboarding/connect_sso");
      }
    }
  });

  $effect(() => {
    // Sometimes a new user may be pushed to this page while the backend is still
    // setting up their claims after first login.
    // We can redirect them again if the org store becomes populated
    if ($selectedOrgStore) {
      push($selectedOrgStore.pagePrefix);
    }
  });
</script>

<div class="grow px-6 lg:px-10 py-5 sm:py-8 lg:py-10 text-offblack">
  <div class="flex justify-between border-b-2 pb-8">
    <div>
      <h2 class="text-[#132c40] text-3xl font-medium font-['Switzer Variable'] leading-[38px] mb-3">How this works</h2>
      <span class="text-black text-base font-normal font-['Switzer Variable'] leading-normal"
        >Here's what to expect before you begin onboarding.</span
      >
    </div>
    <Button disabled={isSubmitting} on:click={startOnboarding}>
      {#if !isSubmitting}
        Start onboarding
      {:else}
        <LoadingSpinner dark />
      {/if}
    </Button>
  </div>

  <div class="grid lg:grid-cols-3 mt-20 gap-12 max-w-7xl mx-auto">
    {#each steps as step, i}
      <div class="flex flex-col gap-4">
        <img src={step.icon} alt={step.title} />
        <span>
          Step {i + 1}
        </span>
        <h3 class="text-[#132c40] text-2xl font-medium font-['Switzer Variable'] leading-[38px] mb-3">
          {step.title}
        </h3>
        <p class=" text-base font-normal font-['Switzer Variable'] leading-normal">
          {step.description}
        </p>
        {#if step.requires}
          <div class="px-6 py-2 bg-white shadow-sm rounded-md mt-2 flex gap-2 items-baseline">
            <span class="font-mono text-yellow-700 bg-yellow-100 border border-yellow-500 text-sm px-2 py-1 rounded-md"
              >Requires</span
            >
            <p class="text-base font-normal font-['Switzer Variable'] leading-normal">
              {step.requires}
            </p>
          </div>
        {/if}
      </div>
    {/each}
  </div>
</div>
